import DailyStatsChartCard from './DailyStatsChartCard';

export default DailyStatsChartCard;
